import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import { Button, FormControl, Modal } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import * as reactDeviceDetect from "react-device-detect";
import _ from "lodash";
import { ClipLoader } from "react-spinners";
// No data found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import "../../routes/app";
import ApprovalBtn from "./ApprovalBtn";

// import EmailPopUp from "./EmailPopUp";
// Icons
import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";
import notificationStatus from "../../assets/img/notificationStatus.png";
import unknownStatus from "../../assets/img/UnknownStatus.png";
import paymentFail from "../../assets/img/PaymentFail.png";
import authorizeIMG from "../../assets/img/Authorize.png";
import updateEmail from "../../assets/img/updateEmail.png";
import updateEmail2 from "../../assets/img/updateEmailTest.png";
import ImpactAlert from "../../assets/img/impact_alert_icon.png";

import UserSettingsIcon from "../../assets/img/UserSettingsIcon.png";
import memberRemovedIcon from "../../assets/img/memberRemovedIcon.png";

import "../../assets/css/maincss.css";

import LocalizedStrings from "react-localization";
import { style } from "variables/Variables.jsx";
let localizationStrings = new LocalizedStrings({
  en: {
    typeTitle: "Type",
    descriptionTitle: "Description",
    deviceTitle: "Device",
    timeTitle: "Time",
    userEmailTitle: "User Email",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    noDataTitle: "There is no data to display",
    refreshTitle: "Refresh",
    accountNotifType: "Account Management",
    lockNotifType: "Lock Access",
    loginNotifType: "Login Request",
    ImpactAlert: "Strong Impact Alert",
    ImpactAlert: "Strong Impact Alert",
    paymentFailNotifType: "Payment Declined",
    paymentFailDescription:
      "Your payment method to renew your subscription has been declined",
    deviceLoginMessage: " has requested to login from a new device",
    lockimpact:
      "Your lock has detected a strong impact. Please inspect it for any signs of ",
    lockimpact2: "physical damage to maintain security.",
    lockimpact3: "",
    updateTitle: "Email Update!",
    updateEmailDescription: " has updated their email!",
    updateEmailSuperAdmin: "You have updated your email!",
    removedMemberDescription: "You have been removed from ",
    memberListTitle: "'s member list.",
  },
  ja: {
    typeTitle: "タイプ",
    descriptionTitle: "説明",
    deviceTitle: "デバイス",
    timeTitle: "時間",
    userEmailTitle: "メンバーEメール",
    resultTitle1: "表示中 ",
    resultTitle2: " から ",
    resultTitle3: " まで ",
    resultTitle4: " 件の結果",
    noDataTitle: "表示するデータがありません。",
    refreshTitle: "リフレッシュ",
    accountNotifType: "アカウント管理",
    lockNotifType: "ロックアクセス",
    loginNotifType: "ログインリクエスト",
    ImpactAlert: "衝撃感知アラーム .",
    paymentFailNotifType: "支払いが行われませんでした",
    paymentFailDescription:
      "サブスクリプションプランのお支払が行われませんでした。",
    deviceLoginMessage:
      " が、新たなデバイスからログインをリクエストをしています。",
    lockimpact:
      "ロックが衝撃を感知しました。ロケーションと時間は表示の通りです。本体と施",
    lockimpact2:
      "錠状態をチェックして下さい。(本体は数分後にオートOFF機能で電源がOFFになります)",
    lockimpact3: "ります)",
    updateTitle: "メール更新！",
    updateEmailDescription: " がメールを更新しました！",
    updateEmailSuperAdmin: "メールを更新しました！",
    removedMemberDescription: "あなたは ",
    memberListTitle: "のメンバーリストから削除されました。",
  },
  es: {
    typeTitle: "Tipo",
    descriptionTitle: "Descripción",
    deviceTitle: "Dispositivo",
    timeTitle: "Hora",
    userEmailTitle: "Correo electrónico del usuario",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    noDataTitle: "No hay datos para mostrar",
    refreshTitle: "Actualizar",
    accountNotifType: "Gestión de cuenta",
    lockNotifType: "Acceso a candado",
    loginNotifType: "Solicitud de inicio de sesión",
    ImpactAlert: "Alerta de Impacto Fuerte",
    paymentFailNotifType: "Pago Rechazado",
    paymentFailDescription:
      "Tu método de pago para renovar tu suscripción ha sido rechazado",
    deviceLoginMessage:
      " ha solicitado iniciar sesión desde un nuevo dispositivo",
    lockimpact:
      "Tu candado ha detectado un fuerte impacto. Por favor, inspecciónala para detectar cualquier signo de ",
    lockimpact2: "daño físico para mantener la seguridad.",
    lockimpact3: "",
    updateTitle: "¡Actualización de Correo Electrónico!",
    updateEmailDescription: " ha actualizado su correo electrónico!",
    updateEmailSuperAdmin: "¡Has actualizado tu correo electrónico!",
    removedMemberDescription: "Has sido eliminado de ",
    memberListTitle: "'s lista de miembros",
  },
});

class NotificationLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityLogsArray: [],
      notificationLogsArray: [],
      logsListArray: [],
      showPopup: false,
      loading: false,
      initialLoading: true,
    };

    this.renderApprovalBtn = this.renderApprovalBtn.bind(this);
    this.updateRequestLogs = this.updateRequestLogs.bind(this);
    this.handleReadButton = this.handleReadButton.bind(this);

    // this.renderEmailPopUp = this.renderEmailPopUp.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentLanguage !== this.state.currentLanguage) {
      this.updateRequestLogs();
    }
  }

  async componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    //! put all notifications under current user into notificationLogsArray
    await fire
      .database()
      .ref("individualNotifications")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let LogsArray = [];

          snapshot.forEach((Log) => {
            let Logval = Log.val();
            let requestLog;
            if (!Logval.isRead) {
              if (Logval.notificationType === 2) {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: false,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription:
                    Logval.senderEmail + localizationStrings.deviceLoginMessage,
                  userEmail: Logval.senderEmail,
                  deviceModel: Logval.deviceModel,
                  deviceUID: Logval.deviceUID,
                  requestToken: Logval.requestToken,
                  time: Logval.timeStamp,
                  status:
                    Math.floor(new Date() / 1000) >
                      Logval.timeStamp / 1000 + 86400 &&
                    Logval.status === "PENDING"
                      ? "EXPIRED"
                      : Logval.status,
                  access: Logval,
                };
              } else if (Logval.notificationType === 3) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.uid,
                  time: Logval.created * 1000,
                  access: Logval,
                };
              } else if (Logval.notificationType === 4) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.memberUid,
                  time: Logval.timeStamp,
                  name: Logval.memberName,
                  oldEmail: Logval.oldEmail,
                  newEmail: Logval.newEmail,
                  access: Logval,
                };
              } else if (Logval.notificationType === 5) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.userUid,
                  superAdminName: Logval.superAdminName,
                  time: Logval.timeStamp,
                };
              } else if (Logval.notificationType === 102) {
                requestLog = {
                  title: Logval.title,
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  tableDescription: Logval.description,
                  uid: Logval.userUid,
                  superAdminName: Logval.superAdminName,
                  time: Logval.timeStamp,
                };
              } else {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription: Logval.description,
                  userEmail: Logval.senderEmail,
                  device: Logval.device,
                  time: Logval.timeStamp, //hit
                  access: Logval,
                };
              }
            } else {
              if (Logval.notificationType === 2) {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: true,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription:
                    Logval.senderEmail + localizationStrings.deviceLoginMessage,
                  userEmail: Logval.senderEmail,
                  deviceModel: Logval.deviceModel,
                  deviceUID: Logval.deviceUID,
                  requestToken: Logval.requestToken,
                  time: Logval.timeStamp,
                  status:
                    Math.floor(new Date() / 1000) >
                      Logval.timeStamp / 1000 + 86400 &&
                    Logval.status === "PENDING"
                      ? "EXPIRED"
                      : Logval.status,
                  access: Logval,
                };
              } else if (Logval.notificationType === 3) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.uid,
                  time: Logval.created * 1000,
                  access: Logval,
                };
              } else if (Logval.notificationType === 4) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.memberUid,
                  time: Logval.timeStamp,
                  name: Logval.memberName,
                  oldEmail: Logval.oldEmail,
                  newEmail: Logval.newEmail,
                  access: Logval,
                };
              } else if (Logval.notificationType === 5) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.userUid,
                  superAdminName: Logval.superAdminName,
                  time: Logval.timeStamp,
                };
              } else if (Logval.notificationType === 102) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.userUid,
                  title: Logval.title,
                  time: Logval.timeStamp,
                  tableDescription: Logval.description,
                };
              } else {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription: Logval.description,
                  userEmail: Logval.senderEmail,
                  device: Logval.device,
                  time: Logval.timeStamp,
                  access: Logval,
                };
              }
            }
            LogsArray.push(requestLog);
          });

          this.setState({
            notificationLogsArray: LogsArray,
          });
        }
      });

    // set requestListData
    const notificationListData = _.map(
      this.state.notificationLogsArray,
      (accessData) => {
        // customLog(accessData);
        if (accessData.Type === 2) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              key: accessData.key,
              snapKey: accessData.snapKey,
              popupDescription: accessData.popupDescription,
              tableDescription: accessData.tableDescription,
              userEmail: accessData.userEmail,
              deviceModel: accessData.deviceModel,
              deviceUID: accessData.deviceUID,
              requestToken: accessData.requestToken,
              status: accessData.status,
              time: accessData.time,
            },
          };
        } else if (accessData.Type === 3) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              key: accessData.key,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 4) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              key: accessData.snapKey,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              name: accessData.name,
              oldEmail: accessData.oldEmail,
              newEmail: accessData.newEmail,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 5) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              superAdminName: accessData.superAdminName,
              time: accessData.time,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 102) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              title: accessData.title,
              access: accessData.access,
              tableDescription: accessData.tableDescription,
            },
          };
        } else {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.key,
              popupDescription: accessData.popupDescription,
              tableDescription: accessData.tableDescription,
              userEmail: accessData.userEmail,
              device: accessData.device,
              time: accessData.time,
              access: accessData.access,
            },
          };
        }
      }
    );

    // sort array by time
    const logsListArray = [...notificationListData].sort((a, b) =>
      a.data.time < b.data.time ? 1 : -1
    );

    this.setState({
      logsListArray: logsListArray,
      initialLoading: false,
    });
  }

  renderApprovalBtn(accessData) {
    return (
      <ApprovalBtn accessData={accessData} refresh={this.updateRequestLogs} />
    );
    // return <ApprovalBtn accessData={accessData} />;
  }

  // renderEmailPopUp(accessData) {
  //   return <EmailPopUp accessData={accessData} refresh={this.updateRequestLogs} />;
  // }

  async updateRequestLogs() {
    this.setState({ loading: true });
    //! put all notifications under current user into notificationLogsArray
    await fire
      .database()
      .ref("individualNotifications")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let LogsArray = [];

          snapshot.forEach((Log) => {
            let Logval = Log.val();
            let requestLog;
            if (!Logval.isRead) {
              if (Logval.notificationType === 2) {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: false,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription:
                    Logval.senderEmail + localizationStrings.deviceLoginMessage,
                  userEmail: Logval.senderEmail,
                  deviceModel: Logval.deviceModel,
                  deviceUID: Logval.deviceUID,
                  requestToken: Logval.requestToken,
                  time: Logval.timeStamp,
                  status:
                    Math.floor(new Date() / 1000) >
                      Logval.timeStamp / 1000 + 86400 &&
                    Logval.status === "PENDING"
                      ? "EXPIRED"
                      : Logval.status,
                  access: Logval,
                };
              } else if (Logval.notificationType === 3) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.uid,
                  time: Logval.created * 1000,
                  access: Logval,
                };
              } else if (Logval.notificationType === 4) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.memberUid,
                  time: Logval.timeStamp,
                  name: Logval.memberName,
                  oldEmail: Logval.oldEmail,
                  newEmail: Logval.newEmail,
                  access: Logval,
                };
              } else if (Logval.notificationType === 5) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.timeStamp,
                  superAdminName: Logval.superAdminName,
                  time: Logval.timeStamp,
                };
              } else if (Logval.notificationType === 102) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.timeStamp,
                  title: Logval.title,
                  time: Logval.timeStamp,
                  tableDescription: Logval.description,
                };
              } else {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription: Logval.description,
                  userEmail: Logval.senderEmail,
                  device: Logval.device,
                  time: Logval.timeStamp,
                  access: Logval,
                };
              }
            } else {
              if (Logval.notificationType === 2) {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: true,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription:
                    Logval.senderEmail + localizationStrings.deviceLoginMessage,
                  userEmail: Logval.senderEmail,
                  deviceModel: Logval.deviceModel,
                  deviceUID: Logval.deviceUID,
                  requestToken: Logval.requestToken,
                  time: Logval.timeStamp,
                  status:
                    Math.floor(new Date() / 1000) >
                      Logval.timeStamp / 1000 + 86400 &&
                    Logval.status === "PENDING"
                      ? "EXPIRED"
                      : Logval.status,
                  access: Logval,
                };
              } else if (Logval.notificationType === 3) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapKey,
                  uid: Logval.uid,
                  time: Logval.created * 1000,
                  access: Logval,
                };
              } else if (Logval.notificationType === 4) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Logval.snapKey,
                  snapKey: Logval.snapkey,
                  uid: Logval.memberUid,
                  time: Logval.timeStamp,
                  name: Logval.memberName,
                  oldEmail: Logval.oldEmail,
                  newEmail: Logval.newEmail,
                  access: Logval,
                };
              } else if (Logval.notificationType === 5) {
                requestLog = {
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.userUid,
                  superAdminName: Logval.superAdminName,
                  time: Logval.timeStamp,
                };
              } else if (Logval.notificationType === 102) {
                requestLog = {
                  key: Logval,
                  key2: Log,
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  snapKey: Logval.snapKey,
                  uid: Logval.userUid,
                  title: Logval.title,
                  time: Logval.timeStamp,
                  tableDescription: Logval.description,
                };
              } else {
                requestLog = {
                  //status false = unread; true = read;
                  isRead: Logval.isRead,
                  Type: Logval.notificationType,
                  key: Log.key,
                  snapKey: Logval.snapKey,
                  popupDescription: Logval.description,
                  tableDescription: Logval.description,
                  userEmail: Logval.senderEmail,
                  device: Logval.device,
                  time: Logval.timeStamp,
                  access: Logval,
                };
              }
            }
            LogsArray.push(requestLog);
          });

          this.setState({
            notificationLogsArray: LogsArray,
          });
        }
      });

    // set requestListData
    const notificationListData = _.map(
      this.state.notificationLogsArray,
      (accessData) => {
        // customLog(accessData);
        if (accessData.Type === 2) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              key: accessData.key,
              snapKey: accessData.snapKey,
              popupDescription: accessData.popupDescription,
              tableDescription: accessData.tableDescription,
              userEmail: accessData.userEmail,
              deviceModel: accessData.deviceModel,
              deviceUID: accessData.deviceUID,
              requestToken: accessData.requestToken,
              status: accessData.status,
              time: accessData.time,
            },
          };
        } else if (accessData.Type === 3) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              key: accessData.key,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 4) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.key,
              // snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              name: accessData.name,
              oldEmail: accessData.oldEmail,
              newEmail: accessData.newEmail,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 5) {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              superAdminName: accessData.superAdminName,
              access: accessData.access,
            },
          };
        } else if (accessData.Type === 102) {
          return {
            data: {
              key: accessData.Logval,
              key2: accessData.Log,
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.snapKey,
              uid: accessData.uid,
              time: accessData.time,
              title: accessData.title,
              access: accessData.access,
              tableDescription: accessData.tableDescription,
            },
          };
        } else {
          return {
            data: {
              isRead: accessData.isRead,
              type: accessData.Type,
              snapKey: accessData.key,
              popupDescription: accessData.popupDescription,
              tableDescription: accessData.tableDescription,
              userEmail: accessData.userEmail,
              device: accessData.device,
              time: accessData.time,
              access: accessData.access,
            },
          };
        }
      }
    );

    // sort array by time
    const logsListArray = [...notificationListData].sort((a, b) =>
      a.data.time < b.data.time ? 1 : -1
    );

    this.setState({
      logsListArray: logsListArray,
      loading: false,
    });
  }

  // Update all notifications under current user to read
  async handleReadButton() {
    await fire
      .database()
      .ref("individualNotifications")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists) {
          snapshot.forEach((snap) => {
            // console.log("snap key: " + snap.key)

            fire
              .database()
              .ref("individualNotifications")
              .child(auth.currentUser.uid)
              .child(snap.key)
              .update({
                isRead: true,
              });
          });
        }
      });

    // after update read status, update the displayed table
    this.updateRequestLogs();
  }

  dateTimeFormat(data) {
    let time = data.time;

    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time / 1000} format="full" includeDay />;
    }
  }

  // highlight background if notification is unread
  columnStyleFormat(data, row, rowIdx, colIdx) {
    if (!data.isRead) {
      return {
        backgroundColor: "#D6EBFF",
      };
    } else {
      return {
        backgroundColor: "transparent",
      };
    }
  }

  iconTypeFormat(data) {
    let type = data.type;

    var styling = {
      width: "70px",
      height: "70px",
    };

    if (type === 0) {
      // return <img style={{width: "50px", height: "50px"}} src={accountManagement} alt="AuthorizeIMG" />;
      return (
        <img style={styling} src={accountManagement} alt="accountManagement" />
      );
    } else if (type === 1) {
      return <img style={styling} src={lockAccess} alt="lockAccess" />;
    } else if (type === 2) {
      return <img style={styling} src={loginRequest} alt="loginRequest" />;
    } else if (type === 3) {
      return <img style={styling} src={paymentFail} alt="paymentFail" />;
    } else if (type === 4) {
      return <img style={styling} src={UserSettingsIcon} alt="updateEmail" />;
    } else if (type === 5) {
      return <img style={styling} src={memberRemovedIcon} alt="memberRemove" />;
    } else if (type === 102) {
      return <img style={styling} src={ImpactAlert} alt="ImpactAlert" />;
    }
    {
      return <img style={styling} src={unknownStatus} alt="unknownStatus" />;
    }

    return <span>Unspecified type</span>;
  }

  descriptionFormat(data) {
    const styling = {
      width: "200px",
      margin: "0",
      padding: "0",
      fontWeight: "normal",
    };
    if (data.type === 0) {
      // return <img style={{width: "50px", height: "50px"}} src={authorizeIMG} alt="AuthorizeIMG" />;
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.accountNotifType}
          </p>
          <span style={styling}>{data.tableDescription}</span>
        </span>
      );
    } else if (data.type === 1) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.lockNotifType}
          </p>
          <span style={styling}>{data.tableDescription}</span>
        </span>
      );
    } else if (data.type === 2) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.loginNotifType}
          </p>
          <span style={styling}>{data.tableDescription}</span>
        </span>
      );
    } else if (data.type === 3) {
      // "Your payment method was declined on {{dateTime}}.""
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.paymentFailNotifType}
          </p>
          <span style={styling}>
            {localizationStrings.paymentFailDescription}
          </span>
        </span>
      );
    } else if (data.type === 4) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.updateTitle}
          </p>
          <span style={styling}>
            {data.uid === auth.currentUser.uid
              ? localizationStrings.updateEmailSuperAdmin
              : data.name + localizationStrings.updateEmailDescription}
          </span>
        </span>
      );
    } else if (data.type === 5) {
      return (
        <span>
          {localizationStrings.removedMemberDescription +
            data.superAdminName +
            localizationStrings.memberListTitle}
        </span>
      );
    } else if (data.type === 102) {
      return (
        <span style={{ height: "50px" }}>
          <p style={{ fontWeight: "bold", margin: "0", padding: "0" }}>
            {localizationStrings.ImpactAlert + " " + data.title}
          </p>
          <span style={styling}>
            {localizationStrings.lockimpact}
            <br />
            {localizationStrings.lockimpact2}
            <br />
            {localizationStrings.lockimpact3}
          </span>
        </span>
      );
    }
    {
      return <span>Unspecified type</span>;
    }
  }

  keyFormat(data) {
    return data.key;
  }

  statusFormat(data) {
    if (!data.isRead) {
      return (
        <img
          style={{ height: "10px", width: "10px" }}
          src={notificationStatus}
          alt="notificationStatus"
        />
      );
    } else {
      return;
    }
  }

  statusStyleFormat(data) {
    let styling = {
      width: "200px",
      margin: "0",
      padding: "0",
      fontWeight: "normal",
      justifyContent: "center",
      textAlign: "center",
      verticalAlign: "center",
      margin: "auto",
      padding: "auto",
    };

    if (!data.isRead) {
      styling = {
        width: "200px",
        margin: "0",
        padding: "0",
        fontWeight: "normal",
        justifyContent: "center",
        textAlign: "center",
        verticalAlign: "center",
        margin: "auto",
        padding: "auto",
        backgroundColor: "#D6EBFF",
      };
    }
    return styling;
  }

  loadingData() {
    if (this.state.initialLoading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    //! For unread notification counter
    //
    // let counter = 0;
    // logsListData.forEach(log => {
    //   if(log.data.isRead === false) {
    //     counter++;
    //   }
    // });

    const override = {
      display: "block",
      margin: "0 auto",
    };

    const logsListData = this.state.logsListArray;

    const customTotal = (from, to, size) =>
      this.state.currentLanguage === "en" ? (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "right" }}
        >
          {localizationStrings.resultTitle1}
          {from}
          {localizationStrings.resultTitle2}
          {to}
          {localizationStrings.resultTitle3}
          {size}
          {localizationStrings.resultTitle4}
        </span>
      ) : this.state.currentLanguage === "ja" ? (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "right" }}
        >
          {localizationStrings.resultTitle1}
          {localizationStrings.resultTitle2}
          {size}
          {localizationStrings.resultTitle3}
          {to}
          {localizationStrings.resultTitle4}
        </span>
      ) : (
        ""
      );

    const options = {
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: logsListData.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };

    const descriptionHover = (cell, row, enumObject, rowIndex) => {
      return cell.desc;
    };

    if (!this.state.loading) {
      return (
        <div>
          <div style={{ height: "30px" }}></div>
          <div
            style={{
              display: "flex",
              margin: "auto",
              padding: "auto",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <button
              onClick={this.updateRequestLogs}
              className={"hoverRefreshBtn notifBtn"}
            >
              {localizationStrings.refreshTitle}
            </button>
          </div>
          <div style={{ height: "10px" }}></div>
          {/* Notification table codes */}
          <BootstrapTable
            pagination={true}
            bordered={false}
            data={logsListData}
            // data={this.state.multiSharingArray}
            // selectRow={selectRowProp}
            // deleteRow
            noDataIndication={this.loadingData()}
            options={options}
          >
            {/* key */}
            <TableHeaderColumn
              dataField="data"
              dataFormat={this.keyFormat}
              isKey={true}
              hidden
            >
              Key
            </TableHeaderColumn>

            {/* read status */}
            <TableHeaderColumn
              dataField="data"
              width="30px"
              dataFormat={this.statusFormat}
              tdStyle={this.statusStyleFormat}
            ></TableHeaderColumn>

            {/* notif type */}
            <TableHeaderColumn
              dataField="data"
              width="100px"
              dataFormat={this.iconTypeFormat}
              tdStyle={this.columnStyleFormat}
            ></TableHeaderColumn>

            {/* description */}
            <TableHeaderColumn
              dataField="data"
              width="50%"
              columnTitle={descriptionHover}
              dataFormat={this.descriptionFormat}
              tdStyle={this.columnStyleFormat}
              // dataFormat={this.dateTimeFormat}
            ></TableHeaderColumn>

            {/* time */}
            <TableHeaderColumn
              width="20%"
              dataField="data"
              dataFormat={this.dateTimeFormat}
              tdStyle={this.columnStyleFormat}
            ></TableHeaderColumn>

            {/* button */}
            <TableHeaderColumn
              width="20%"
              dataField="data"
              dataFormat={this.renderApprovalBtn}
              tdStyle={this.columnStyleFormat}
            ></TableHeaderColumn>
          </BootstrapTable>
          <div style={{ height: "200px" }}></div>
        </div>
      );
    } else {
      return (
        <div style={{ marginTop: "20%" }}>
          <span className={"text-danger"}>{this.state.errorMessage}</span>
          <NotificationSystem ref="notificationSystem" style={style} />
          {/* <ClipLoader
            css={override}
            size={150}
            color={"#a9a9a9"}
            loading={this.state.loading}
          /> */}
          <div style={{ textAlign: "center" }}>
            <Loading />
          </div>
        </div>
      );
    }
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(NotificationLogs);
